import script from "./BaseDialog.vue?vue&type=script&lang=ts&setup=true"
export * from "./BaseDialog.vue?vue&type=script&lang=ts&setup=true"

import "./BaseDialog.vue?vue&type=style&index=0&id=2dccaf6d&lang=scss&scoped=true"

import exportComponent from "/app/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-2dccaf6d"]])

export default __exports__